import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbDateStruct, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RequestStatusService } from 'src/app/components/requeststatus/requeststatus.service';
import { CannotContainOnlySpaceValidator } from 'src/app/directives/cannot-contain-only-space-validator.directive';
import { MarkFormGroupTouchedAndDirty } from 'src/app/directives/mark-form-group-as-touched-dirty.function';
import { StatusUpdateSendGroupModel } from 'src/app/models/status/status-sendgroup.model';

export const StatusEditSendgroupDetailsOptions: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  centered: true,
  size: 'md'
};

@Component({
    templateUrl: './status-edit-sendgroup-details.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StatusEditSendgroupDetailsModal implements OnInit {
  private _sendgroupToUpdate!: StatusUpdateSendGroupModel;
  @Input() set sendgroupToUpdate(val: StatusUpdateSendGroupModel) {
    this._sendgroupToUpdate = val;
  }
  get sendgroupToUpdate(): StatusUpdateSendGroupModel {
    return this._sendgroupToUpdate;
  }
  /** Name of the sendgroup */
  @Output('setName') setName: EventEmitter<any> = new EventEmitter();
  /** allow Selecting of Earlier Deadlines than input? */
  @Input() useInitialAsMinDeadline = false;

  @Output() newPickedDeadlineEventEmitter: EventEmitter<Date> = new EventEmitter();

  name!: string;
  form!: UntypedFormGroup;
  nameValue: FormControl;
  deadlineValue: UntypedFormControl;
  minDate: { year: number; month: number; day: number; };
  minDeadline: Date = new Date(new Date().setDate(new Date().getDate() + 1));
  model: NgbDateStruct | undefined;
  date!: string;
  time!: string;
  minDateMobile!: string;
  startDate: { year: number; month: number; day: number; };

  constructor(private formBuilder: UntypedFormBuilder, private activeModal: NgbActiveModal, private requestStatusService: RequestStatusService) {
    this.nameValue = new FormControl("", [Validators.required, CannotContainOnlySpaceValidator()]);
    this.deadlineValue = new UntypedFormControl('');
    this.form = this.formBuilder.group(
      {
        name: this.nameValue,
        deadline: this.deadlineValue
      }
    );
    this.startDate = { year: this.minDeadline.getFullYear(), month: this.minDeadline.getMonth() + 1, day: this.minDeadline.getDate() };
    this.minDate = { year: this.minDeadline.getFullYear(), month: this.minDeadline.getMonth() + 1, day: this.minDeadline.getDate() };
  }

  ngOnInit() {
    this.form.controls['name'].setValue(this.sendgroupToUpdate.sendGroupName);
    this.form.controls['deadline'].setValue(this.sendgroupToUpdate.deadline);

    if(this.sendgroupToUpdate.deadline) {
      let deadline = new Date(this.sendgroupToUpdate.deadline);
      let hours = ("0" + deadline.getHours()).slice(-2);
      let minutes = ("0" + deadline.getMinutes()).slice(-2);
      this.time = hours + ":" + minutes;
      this.date = (new Date(deadline)).toISOString().substring(0, 10);
      this.startDate = { year: deadline.getFullYear(), month: deadline.getMonth() + 1, day: deadline.getDate() };
      this.minDateMobile = (new Date(deadline)).toISOString().substring(0, 10);
    }

    if (this.useInitialAsMinDeadline && this.sendgroupToUpdate.deadline) {
      this.minDate = { year: this.sendgroupToUpdate.deadline.getFullYear(), month: this.sendgroupToUpdate.deadline.getMonth() + 1, day: this.sendgroupToUpdate.deadline.getDate() };
    }
  }

  public closeModal() {
    this.activeModal.close();
  }

  save() {
    if (this.form.invalid) {
      MarkFormGroupTouchedAndDirty(this.form);
      return;
    }
    let newName = this.form.controls['name'].value;
    this.sendgroupToUpdate.sendGroupName = newName;
    this.requestStatusService.updateSendgroup(this.sendgroupToUpdate);
    this.closeModal();
  }

  hours(i: number) {
    return new Array(i);
  }

  changeDeadline(event: any) {
    this.sendgroupToUpdate.deadline = event;
  }

  changeDeadlineMobile(event: Event) {
    let dateString: string = (event.target as HTMLInputElement).value;
    let dateStringArray: string[] = dateString.split('-')
    this.sendgroupToUpdate.deadline = new Date(Number(dateStringArray[0]), Number(dateStringArray[1]) - 1, Number(dateStringArray[2]), new Date(this.sendgroupToUpdate.deadline!).getHours(), new Date(this.sendgroupToUpdate.deadline!).getMinutes());
  }

  changeDeadlineTime(event: Event) {
    let timeString: string = (event.target as HTMLInputElement).value;
    let timeStringArray: string[] = timeString.split(':');
    this.sendgroupToUpdate.deadline = new Date(new Date(this.sendgroupToUpdate.deadline!).getFullYear(), new Date(this.sendgroupToUpdate.deadline!).getMonth(), new Date(this.sendgroupToUpdate.deadline!).getDate(), Number(timeStringArray[0]), Number(timeStringArray[1]));
  }

  changeDeadlineTimeMobile(event: Event) {
    let timeString: string = (event.target as HTMLInputElement).value;
    let timeStringArray: string[] = timeString.split(':');
    this.sendgroupToUpdate.deadline = new Date(new Date(this.sendgroupToUpdate.deadline!).getFullYear(), new Date(this.sendgroupToUpdate.deadline!).getMonth(), new Date(this.sendgroupToUpdate.deadline!).getDate(), Number(timeStringArray[0]), Number(timeStringArray[1]));
  }

  updateDeadlineDays(days: number) {
    this.sendgroupToUpdate.deadlineDays = days;
  }
}
